<div class="form-wrapper">
    <app-vendor-dashboard *ngIf="userType === 'Vendor'"></app-vendor-dashboard>
    <app-employee-dashboard *ngIf="userType === 'Employee'"></app-employee-dashboard>
  </div>